export const PaymentStateEnum  = {
    AUTHORIZED: "AUTHORIZED",
    PENDING: "PENDING",
    REDIRECT: "REDIRECT"
}
